module.exports = __webpack_public_path__ + "static/TheFireSmartHub-8d06bd6bc275d2d169b5df1245a1ff85.mp4";